import { ActionIcon } from "@mantine/core"
import { IconChevronLeft } from "@tabler/icons-react"
import { useCanGoBack, useNavigate } from "@tanstack/react-router"

export function NavigateBackButton() {
  const nav = useNavigate()
  const canGoBack = useCanGoBack()
  return (
    <ActionIcon
      onClick={() => (canGoBack ? history.back() : nav({ to: ".." }))}
      variant="subtle"
    >
      <IconChevronLeft />
    </ActionIcon>
  )
}
